// import { useEffect } from 'react';
import styled from 'styled-components';

export const RadioComponent = styled.div<{ checked: boolean, $size?: number, $difference: number, disabled?: boolean }>`
  width: 20px;
  height: 20px;
  ${({ $size }) => $size && `width: ${$size}px; height: ${$size}px;`}
  border: 2px solid inset ${({ theme, disabled }) => disabled ? theme.lightGray : theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex: none;

  -webkit-box-shadow: inset 0px 0px 0px 2px
    ${({ theme, checked, disabled }) => (disabled ? theme.lightGray : checked ? theme.primary : theme.lightGray)};
  -moz-box-shadow: inset 0px 0px 0px 2px
    ${({ theme, checked, disabled }) => (disabled ? theme.lightGray : checked ? theme.primary : theme.lightGray)};
  box-shadow: inset 0px 0px 0px 2px
    ${({ theme, checked, disabled }) => (disabled ? theme.lightGray : checked ? theme.primary : theme.lightGray)};

  cursor: pointer;

  span {
    width: ${({ $size, $difference }) => $size ? $size - $difference : 10}px;
    height: ${({ $size, $difference }) => $size ? $size - $difference : 10}px;
    background-color: ${({ theme, disabled }) => disabled ? theme.lightGray : theme.primary};
    border-radius: 50%;
  }
`;

export const Radio = ({ checked, size, difference = 0, onClick, disabled = false }: { checked: boolean, size?: number, difference?: number, onClick?: (e: React.MouseEvent<HTMLDivElement>) => void, disabled?: boolean }) => {
  return (
    <RadioComponent checked={checked} $size={size} $difference={difference} onClick={onClick} disabled={disabled}>
      {checked && <span></span>}
    </RadioComponent>
  );
};
